import { DataTableColumns } from 'interfaces/DataTableColumns'
import { ParcelDirectBulkCreateInterface, ZBoomParcelInterface } from 'interfaces/ZBoomParcelInterface'
import Api from './Api'

class ZBoomParcel extends Api {
  readonly urls = {
    allParcels: '/ZBoomParcel/GetAllParcels',
    createParcel: '/ZBoomParcel/ParcelDirectBulkCreate',
    createOrder: '/ZBoomParcel/CreateOrder',
  }

  all = async (
    skip: number,
    top: number = 10,
    searchableColumns: DataTableColumns[] = [],
    searchText: string = '',
  ): Promise<any> => {
    var filter = 'true'
    if (searchText.trim() != '') {
      filter = `(contains(cast(originFullName,'Edm.String'),'${searchText}')or contains(cast(destinationFullName,'Edm.String'),'${searchText}'))`
    }
    const result = await this.postJsonData(
      `${this.urls.allParcels}?$top=${top}&$skip=${
        skip * top
      }&$orderby=id desc&$filter=${filter}`,
    )
    return result.data
  }

  create = async (data: ParcelDirectBulkCreateInterface): Promise<any> => {
    const result = await this.postJsonData(
      this.urls.createParcel,
      {
        weight: data.weight,
        originPharmacyId: data.originPharmacyId,
        destinationPharmacyId: data.destinationPharmacyId,
      },
    )
    return result.data
  }

  createOrder = async (parcelIds: number[]): Promise<any> => {
    const result = await this.postJsonData(
      this.urls.createOrder,
      {
        parcelIds: parcelIds,
      },
    )
    return result.data
  }
}

export default new ZBoomParcel()
